export default __webpack_public_path__ + "static/derrick-d818b1d609682a424878c1187c01ff4d.jpeg";